<!-- eslint-disable vue/multi-word-component-names -->
<template>
    <div
        :class="['el-scrollbar__bar', orientationClass]"
        @mousedown="clickTrackHandler"
    >
        <div
            ref="thumb"
            class="el-scrollbar__thumb"
            :style="thumbStyle"
            @mousedown.stop="clickThumbHandler"
        />
    </div>
</template>

<script setup>
import { ref, computed, onBeforeUnmount } from 'vue';

const props = defineProps({
    vertical: Boolean,
    size: { type: String, default: '' },
    move: { type: Number, default: 0 },
});

const emit = defineEmits(['set-scroll']);

const thumb = ref(null);

const bar = computed(() => {
    return props.vertical
        ? { axis: 'Y', direction: 'top', offset: 'offsetHeight', scroll: 'scrollTop', client: 'clientY' }
        : { axis: 'X', direction: 'left', offset: 'offsetWidth', scroll: 'scrollLeft', client: 'clientX' };
});

const orientationClass = computed(() =>
    props.vertical ? 'is-vertical' : 'is-horizontal',
);

const thumbStyle = computed(() =>
    props.vertical
        ? {
            height: props.size,
            transform: `translateY(${props.move}%)`,
        }
        : {
            width: props.size,
            transform: `translateX(${props.move}%)`,
        },
);

let cursorDown = false;
let start = 0;

function clickThumbHandler(e) {
    cursorDown = true;
    start = e[bar.value.client];
    document.addEventListener('mousemove', mouseMoveDocumentHandler);
    document.addEventListener('mouseup', mouseUpDocumentHandler);
}

function clickTrackHandler(e) {
    const offset = e.currentTarget.getBoundingClientRect()[bar.value.direction];
    const thumbSize = thumb.value[bar.value.offset];
    const clickPos = e[bar.value.client] - offset - thumbSize / 2;
    emit('set-scroll', clickPos / e.currentTarget[bar.value.offset]);
}

function mouseMoveDocumentHandler(e) {
    if (!cursorDown) return;

    const offset = e[bar.value.client] - start;
    const track = thumb.value.parentNode[bar.value.offset] - thumb.value[bar.value.offset];
    emit('set-scroll', offset / track);
}

function mouseUpDocumentHandler() {
    cursorDown = false;
    document.removeEventListener('mousemove', mouseMoveDocumentHandler);
    document.removeEventListener('mouseup', mouseUpDocumentHandler);
}

onBeforeUnmount(() => {
    document.removeEventListener('mousemove', mouseMoveDocumentHandler);
    document.removeEventListener('mouseup', mouseUpDocumentHandler);
});
</script>
